import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-564421c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "config" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "left_wrap" }
const _hoisted_4 = {
  key: 0,
  class: "enterprise-setting"
}
const _hoisted_5 = { class: "choose" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "展示端口", -1))
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "企业信息")
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { style: {"width":"100px","height":"100px"} }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  style: {"width":"100px","height":"100px"}
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "不超过200k，建议尺寸64 x64px", -1))
const _hoisted_15 = {
  class: "item",
  style: {"margin-top":"0"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "招商介绍（非必填）")
], -1))
const _hoisted_17 = { style: {"box-sizing":"border-box","padding-right":"5px"} }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品信息", -1))
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "能力标签", -1))
const _hoisted_24 = { style: {"word-spacing":"-4px","margin-top":"24px"} }
const _hoisted_25 = { style: {"padding":"24px 0 0"} }
const _hoisted_26 = { class: "right" }
const _hoisted_27 = { class: "content" }

import XrkTinymce from '@/components/xrk/tinymce';
import { computed, reactive, ref, nextTick } from 'vue';
import {
  BaseButton,
  BaseButtonProps,
  BaseCheckbox,
  BaseCheckboxGroup,
  BaseEmpty,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseIcon,
  BaseInput,
  XrkMessage,
  createDialog,
  BaseUpload,
  BaseImage,
  BaseTextContent
} from 'xrk-components';
import { ConfigProductVue, chooseProduct } from '../components/config-product';
import { ConfigTagsVue, chooseTags } from '../components/config-tags';
import { Zs, Product, TagType, ZsEditType } from '../data-source/types';
import {
  CircleCheckFilled,
  WarningFilled,
  CircleCloseFilled
} from '@element-plus/icons-vue';
import { ConfigDetailVue } from '../components/config-detail';
import { useZsStore } from '../store';
import {
  ROAD_TYPE,
  ROAD_TYPE_MAP,
  STATUS_NO_CONFIRM_VALUE,
  STATUS_NO_RELEASED_VALUE,
  STATUS_REJECT_VALUE,
  STATUS_RELEASED_VALUE,
  STATUS_SUSPEND_VALUE,
  PUBLISH_SOURCE_SYSTEM,
  PUBLISH_SOURCE_COMPANY,
  ROAD_WEB_VALUE,
  ROAD_MINI_VALUE,
  ROAD_APP_VALUE
} from '../config';
import {
  editConfig,
  getConfig,
  setConfigStatus,
  autoUploadImge,
  queryZsProtocol
} from '../data-source/api';
import router from '@/router';
import { useRoute } from 'vue-router';
import { imgSvg } from '../router/index';
import { usePreviewWebviewInvestmentUrl } from '@hooks/webview';


export default /*#__PURE__*/_defineComponent({
  __name: 'zs-manage-config',
  setup(__props) {

const route = useRoute();

const {
  isOwnPublish,
  isOtherPublish,
  isOssRole,
  enterpriseId,
  enterpriseName,
  setValue,
  configId
} = useZsStore();

const ConfigTagsRef = ref<InstanceType<typeof ConfigTagsVue>>();
const ConfigProductRef = ref<InstanceType<typeof ConfigProductVue>>();

const _roleName = isOssRole.value ? '企业' : '平台';
const configStatusMap = {
  review: {
    icon: WarningFilled,
    color: '--xrk-color-primary',
    message: `提示：招商内容已发布，${_roleName}审核中`
  },
  success: {
    icon: CircleCheckFilled,
    color: '--xrk-color-success',
    message: `提示：${_roleName}已审核通过`
  },
  fail: {
    icon: CircleCloseFilled,
    color: '--xrk-color-error',
    message: '驳回：'
  }
};
const zsIsAudit = ref(0);
const loading = ref(true);
const isStop = ref(false);
const configStatus = ref<keyof typeof configStatusMap | ''>('');
const failReason = ref('');
const configStatusObj = computed(() => {
  const res = configStatusMap[configStatus.value];
  if (!res) return void 0;
  return {
    ...res,
    message:
      configStatus.value === 'fail'
        ? `${res.message}${failReason.value}`
        : res.message
  };
});
const edit = ref(false);
const formData = reactive<{
  id?: number;
  content: Zs['row']['introduce'];
  productData: Zs['row']['productList'];
  tags: Zs['row']['tags'];
  platforms: Zs['row']['platforms'];
}>({
  content: '',
  productData: [],
  tags: [],
  platforms: Object.keys(ROAD_TYPE_MAP) as any
});

//logo_________________
const loginFileList = ref([]);
let logoFormData = ref({
  enterpriseLogo: '',
  agreement: false,
  agreementDiseab: false
});

const logoHttpRequest = async ({ file }) => {
  const res = await autoUploadImge({ file });
  logoFormData.value.enterpriseLogo = res.data.fileUrl;
};
const logoError = errorInfo => {
  if (errorInfo.code == 501) {
    XrkMessage.error('图片最大支持200k');
  }
  if (errorInfo.code == 503) {
    XrkMessage.error('图片类型为jpg、jpeg、png');
  }
};
const agreementDioalog = async () => {
  let res = await queryZsProtocol();
  createDialog({
    title: '向日葵平台企业招商服务使用及管理规则',
    showClose: true,
    showFooter: false,
    width: '960px',
    contentRender: () => {
      return (
        <BaseTextContent>
          <div
            v-html={res.data.content}
            style={{ background: '#F2F2F7', borderRadius: '8px 8px 8px 8px' }}
          ></div>
        </BaseTextContent>
      );
    }
  });
};

const initData = async () => {
  try {
    if (isOssRole.value && !configId.value) {
      edit.value = true;
      loading.value = false;
      configStatus.value = '';
      formData.platforms = Object.keys(ROAD_TYPE_MAP).map(i => +i) as any;
      return;
    }
    const { data } = await getConfig({ configId: configId.value });
    if (!data) {
      edit.value = true;
      loading.value = false;
      configStatus.value = '';
    } else if (data && Object.keys(data).length > 0) {
      logoFormData.value.enterpriseLogo = data.enterpriseLogo;
      loginFileList.value = [
        {
          url: data.enterpriseLogo,
          name: '企业logo'
        }
      ];
      logoFormData.value.agreement = data.agreementDt ? true : false;
      logoFormData.value.agreementDiseab = data.agreementDt ? true : false;
      formData.id = data.id;
      formData.content = data.introduce;
      formData.productData = data.productList;
      formData.tags = data.tags;
      formData.platforms = data.platforms;
      zsIsAudit.value = data.zsIsAudit;
      switch (data.auditStatus) {
        case STATUS_NO_RELEASED_VALUE:
          configStatus.value = '';
          break;
        case STATUS_NO_CONFIRM_VALUE:
          configStatus.value = 'review';
          break;
        case STATUS_RELEASED_VALUE:
          configStatus.value = 'success';
          break;
        case STATUS_REJECT_VALUE:
          configStatus.value = 'fail';
          break;
        case STATUS_SUSPEND_VALUE:
          {
            configStatus.value = 'success';
            isStop.value = true;
          }
          break;
      }
      failReason.value = data.reason || '';
      edit.value = !['review', 'success', 'fail'].includes(configStatus.value);
      if (
        (isOssRole.value && data.source == PUBLISH_SOURCE_SYSTEM) ||
        (!isOssRole.value && data.source == PUBLISH_SOURCE_COMPANY)
      ) {
        setValue('dataOrigin', 'own');
      } else {
        setValue('dataOrigin', 'other');
      }
    }
    loading.value = false;
  } catch (error) {
    loading.value = false;
  }
};

const onTinymceInput = (value: string) => {
  formData.content = value;
};

const onAddProductClick = async () => {
  const data = (await chooseProduct(
    new Set(formData.productData.map(i => i.productId as number))
  )) as any;
  ConfigProductRef.value?.pushData?.(data);
};

const onAddTagsClick = async () => {
  const data = await chooseTags(
    new Set(formData.tags?.map(i => i.id as number))
  );
  formData.tags.push(
    ...data.map(i => ({ ...i, required: true, chooseTagValues: [] }))
  );

  nextTick(() => {
    const el = document.querySelector('.ability-label');
    el?.scrollIntoView({
      block: 'end',
      inline: 'center',
      behavior: 'smooth'
    });
  });
};
initData().then(() => {
  nextTick(() => {
    formData.productData.length > 0 &&
      ConfigProductRef.value?.pushData?.(
        formData.productData as Array<Product['row']>
      );
  });
});

const checkFormData = (() => {
  const TEXT_MAX_LENGTH = 2000;
  const PRODUCT_MIN_COUNT = 1;
  const PRODUCT_MAX_COUNT = 30;
  const TAG_MIN_COUNT = 1;
  const TAG_MAX_COUNT = 10;
  return async () => {
    let errStr = '';
    const checks = [
      () => {
        if (!formData.content) return;
        const div = document.createElement('div');
        div.innerHTML = formData.content;
        // eslint-disable-next-line no-irregular-whitespace
        const text = div.innerText.replace(/[\n|' '|' ']/g, '');
        if (text.length > TEXT_MAX_LENGTH)
          return `富文本编辑器最多输入${TEXT_MAX_LENGTH}字符长度内容`;
        return '';
      },
      () => {
        if (
          formData.productData.length > PRODUCT_MAX_COUNT ||
          formData.productData.length < PRODUCT_MIN_COUNT
        ) {
          return `至少需要添加${PRODUCT_MIN_COUNT}个产品，最多添加${PRODUCT_MAX_COUNT}个`;
        }
        return '';
      },
      () => {
        if (
          formData.tags.length > TAG_MAX_COUNT ||
          formData.tags.length < TAG_MIN_COUNT
        ) {
          return `能力标签至少需要添加${TAG_MIN_COUNT}个能力标签，最多添加${TAG_MAX_COUNT}个`;
        }
        const emptyTag = formData.tags.find(
          item => item.chooseTagValues?.length == 0
        );
        if (emptyTag) return `${emptyTag.name}至少选择一项`;
        return '';
      }
    ];
    for (const check of checks) {
      let _err = check();
      if (_err) {
        errStr = _err;
        break;
      }
    }
    if (errStr) {
      XrkMessage.error(errStr);
      return Promise.reject(errStr);
    }
    return Promise.resolve();
  };
})();

const cancelBtnConfig: BaseButtonProps & { show: boolean; content: string } = {
  show: true,
  type: 'default',
  content: '取消'
};
const confirmBtnConfig: BaseButtonProps & { show: boolean; content: string } = {
  show: true,
  type: 'primary',
  content: '确认'
};

const saveConfig = async (isPublish: 0 | 1) => {
  const { data: _configId } = await editConfig({
    enterpriseLogo: logoFormData.value.enterpriseLogo,
    enterpriseId: enterpriseId.value,
    id: formData.id,
    introduce: formData.content,
    productIdList: formData.productData.map(i => i.productId as number),
    isPublish: isPublish,
    zsWebIsShow: formData.platforms.includes(ROAD_WEB_VALUE) ? 1 : 0,
    zsWxIsShow: formData.platforms.includes(ROAD_MINI_VALUE) ? 1 : 0,
    zsAppIsShow: formData.platforms.includes(ROAD_APP_VALUE) ? 1 : 0,
    labelList: formData.tags.map(tag => ({
      labelId: (tag.id && +tag.id) as number,
      isMustFill: tag.required ? 1 : 0,
      isLocation: tag.isLocation ? 1 : 0,
      optionIdList: (tag.chooseTagValues?.map(i => +i) || []).filter(
        Boolean
      ) as number[],
      areaList: tag.chooseTagValues
        ?.map(area => {
          if (Array.isArray(area)) {
            return {
              provinceId: area[0],
              cityId: area[1],
              isAll: tag._provinceChooseAllMap.get(+area[0]) || false
            };
          }
          return {
            provinceId: 0,
            cityId: 0
          };
        })
        .filter(
          i => i.provinceId
        ) as ZsEditType['labelList'][number]['areaList']
    }))
  });
  _configId &&
    (formData.id = _configId) &&
    configId.value != _configId &&
    router.replace({
      query: {
        ...(route.query || {}),
        configId: _configId
      }
    });
};

const onSaveClick = async () => {
  // 保存
  // if ([null, '', undefined].includes(logoFormData.value.enterpriseLogo)) {
  //   XrkMessage.error('请上传企业logo');
  //   return;
  // }
  // if (!logoFormData.value.agreement) {
  //   XrkMessage.error('请勾选《向日葵平台企业招商服务使用及管理规则》同意条款');
  //   return;
  // }
  await checkFormData();
  await saveConfig(0);
  configStatus.value = '';
  XrkMessage.success('保存成功');
};
const onPublishClick = async () => {
  // 发布
  if ([null, '', undefined].includes(logoFormData.value.enterpriseLogo)) {
    XrkMessage.error('请上传企业logo');
    return;
  }
  if (!logoFormData.value.agreement) {
    XrkMessage.error('请勾选《向日葵平台企业招商服务使用及管理规则》同意条款');
    return;
  }
  try {
    await checkFormData();
    await saveConfig(1);
    await initData();
    ConfigTagsRef.value?.initAddressData?.();
  } catch (error) {
    console.log(error);
  }
  // edit.value = false;
  // configStatus.value = 'review';
};
const onStartClick = () => {
  // 启用
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <p style={'text-align:center;'}>是否确认启用招商？</p>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_RELEASED_VALUE
      });
      isStop.value = false;
      XrkMessage.success('操作成功');
    }
  });
};
const onStopClick = () => {
  // 暂停
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <p style={'text-align:center;'}>是否确认暂停招商？</p>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_SUSPEND_VALUE
      });
      isStop.value = true;
      XrkMessage.success('操作成功');
    }
  });
};
const onRevokeClick = async () => {
  const fn = async () => {
    await setConfigStatus({
      configId: formData.id as number,
      status: STATUS_NO_RELEASED_VALUE
    });
    edit.value = true;
    configStatus.value = '';
  };
  // 撤回
  if (zsIsAudit.value == 1 || isOssRole.value) {
    createDialog({
      title: '提示',
      width: 400,
      contentRender: () => (
        <BaseTextContent>
          <p style={'text-align:center;'}>
            撤回后再次提交需要{_roleName}审核，是否确认撤回？
          </p>
        </BaseTextContent>
      ),
      cancelBtnConfig,
      confirmBtnConfig,
      beforeConfirm: fn
    });
  } else {
    await fn();
  }
};
const onReEditClick = async () => {
  // 重新编辑
  const fn = async () => {
    await setConfigStatus({
      configId: formData.id as number,
      status: STATUS_NO_RELEASED_VALUE
    });
    edit.value = true;
    configStatus.value = '';
  };
  if (zsIsAudit.value == 1 || isOssRole.value) {
    createDialog({
      title: '提示',
      width: 400,
      contentRender: () => (
        <BaseTextContent>
          <p style={'text-align:center;'}>
            重新编辑需要{_roleName}再次审核，是否确认重新编辑？
          </p>
        </BaseTextContent>
      ),
      cancelBtnConfig,
      confirmBtnConfig,
      beforeConfirm: fn
    });
  } else {
    await fn();
  }
};

const onSuccessClick = () => {
  if (!logoFormData.value.agreement) {
    XrkMessage.error('请勾选《向日葵平台企业招商服务使用及管理规则》同意条款');
    return;
  }
  // 审核-通过 确认发布
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <p style={'text-align:center;'}>是否确认发布？</p>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_RELEASED_VALUE
      });
      configStatus.value = 'success';
      XrkMessage.success('操作成功');
    }
  });
};
const onFailClick = () => {
  const FailFormRef = ref<BaseFormRef>();
  const failFormData = reactive({
    reason: ''
  });
  // 审核-不通过  驳回修改
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <BaseForm
          model={failFormData}
          ref={FailFormRef}
          rules={{ reason: { required: true, message: '填写驳回原因' } }}
        >
          <BaseFormItem prop={'reason'}>
            <BaseInput
              style={{ width: '100%' }}
              type="textarea"
              resize="none"
              modelValue={failFormData.reason}
              onInput={(val: string) => (failFormData.reason = val)}
              maxlength={100}
              showWordLimit
              rows={4}
              placeholder="请输入驳回原因（最多100字符长度）"
            ></BaseInput>
          </BaseFormItem>
        </BaseForm>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await FailFormRef.value?.validate();
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_REJECT_VALUE,
        reason: failFormData.reason
      });
      configStatus.value = 'fail';
      XrkMessage.success('操作成功');
    }
  });
};

const onCopyClick = async () => {
  // await checkFormData();
  // await saveConfig(0);
  // 保存后可用
  const input = document.createElement('input') as HTMLInputElement;
  input.style.opacity = '0';
  input.style.position = 'fixed';
  input.value = usePreviewWebviewInvestmentUrl(configId.value);
  document.body.appendChild(input);
  input.select();
  document.execCommand('Copy');
  document.body.removeChild(input);
  XrkMessage.success('复制成功');
};
const previewLogo = url => {
  createDialog({
    title: '预览',
    width: 500,
    showClose: true,
    contentRender: () => (
      <BaseTextContent>
        <img style={{ width: '100%', height: '100%' }} src={url}></img>
      </BaseTextContent>
    ),
    cancelBtnConfig: {
      show: false
    },
    confirmBtnConfig: {
      show: false
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(isOssRole))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(BaseInput), {
                style: {"width":"100%"},
                "model-value": _unref(enterpriseName),
                disabled: ""
              }, null, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_unref(BaseCheckboxGroup), {
                  class: "box",
                  min: 1,
                  modelValue: formData.platforms,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.platforms) = $event)),
                  disabled: !edit.value || !_unref(isOwnPublish)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ROAD_TYPE), (item) => {
                      return (_openBlock(), _createBlock(_unref(BaseCheckbox), {
                        key: item.value,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (configStatus.value && configStatusObj.value && !edit.value && _unref(isOwnPublish))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: _normalizeStyle([{"display":"flex","align-items":"center","gap":"8px","padding":"9px 14px","font-weight":"bold","margin-bottom":"12px","border-radius":"2px","font-size":"14px"}, `background:var(${configStatusObj.value.color}-light-8);color:var(${configStatusObj.value.color});`])
            }, [
              _createVNode(_unref(BaseIcon), { size: 18 }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(configStatusObj.value.icon)))
                ]),
                _: 1
              }),
              _createElementVNode("div", null, _toDisplayString(configStatusObj.value.message), 1)
            ], 4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(BaseForm), {
            labelPosition: "top",
            model: _unref(logoFormData)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "企业logo",
                prop: "enterpriseLogo",
                required: true
              }, {
                default: _withCtx(() => [
                  (
                  _unref(isOtherPublish) ||
                  ['review', 'success', 'fail'].includes(configStatus.value)
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_unref(BaseImage), {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (previewLogo(_unref(logoFormData).enterpriseLogo))),
                            src: _unref(logoFormData).enterpriseLogo
                          }, null, 8, ["src"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_unref(BaseUpload), {
                          style: {"width":"100%"},
                          fileList: loginFileList.value,
                          "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((loginFileList).value = $event)),
                          listType: "picture-card",
                          limitSize: 0.2,
                          limit: 1,
                          accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                          "http-request": logoHttpRequest,
                          autoUpload: true,
                          onError: logoError,
                          uploadBtnProps: { limitOverHide: true }
                        }, {
                          tip: _withCtx(() => [
                            _hoisted_14
                          ]),
                          default: _withCtx(() => [
                            (_unref(logoFormData).enterpriseLogo)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_unref(BaseImage), {
                                    src: _unref(logoFormData).enterpriseLogo
                                  }, null, 8, ["src"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  innerHTML: _unref(imgSvg)
                                }, null, 8, _hoisted_13))
                          ]),
                          _: 1
                        }, 8, ["fileList"])
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_unref(XrkTinymce), {
              class: _normalizeClass(!edit.value || !_unref(isOwnPublish) ? 'dis-edit' : ''),
              value: formData.content,
              onInput: onTinymceInput
            }, null, 8, ["class", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_unref(BaseButton), {
              class: "btn",
              plain: "",
              onClick: onAddProductClick,
              disabled: !edit.value || !_unref(isOwnPublish)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 添加产品 ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createVNode(_unref(ConfigProductVue), {
            disabled: !edit.value || !_unref(isOwnPublish),
            ref_key: "ConfigProductRef",
            ref: ConfigProductRef,
            onChange: _cache[3] || (_cache[3] = newData => (formData.productData = newData))
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_unref(BaseButton), {
              class: "btn",
              plain: "",
              onClick: onAddTagsClick,
              disabled: !edit.value || !_unref(isOwnPublish)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 选择能力标签 ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          (formData.tags.length == 0)
            ? (_openBlock(), _createBlock(_unref(BaseEmpty), {
                key: 0,
                style: {"padding":"0"},
                "image-size": 80,
                description: "暂未选择能力标签"
              }))
            : (_openBlock(), _createBlock(_unref(ConfigTagsVue), {
                class: "ability-label",
                key: formData.tags.length,
                disabled: !edit.value || !_unref(isOwnPublish),
                data: (formData.tags as Array<TagType>),
                onChange: _cache[4] || (_cache[4] = newTags => (formData.tags = newTags)),
                ref_key: "ConfigTagsRef",
                ref: ConfigTagsRef
              }, null, 8, ["disabled", "data"]))
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_unref(BaseCheckbox), {
            disabled: 
              _unref(isOtherPublish)
                ? ['success', 'fail'].includes(configStatus.value)
                : ['review', 'success', 'fail'].includes(configStatus.value)
            ,
            modelValue: _unref(logoFormData).agreement,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(logoFormData).agreement) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createTextVNode(" 我已阅读并同意 "),
                _createVNode(_unref(BaseButton), {
                  onClick: agreementDioalog,
                  type: "text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 《向日葵平台企业招商服务使用及管理规则》 ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["disabled", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        (_unref(isOtherPublish))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (configStatus.value === 'review')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_unref(BaseButton), { click: onSuccessClick }, {
                      default: _withCtx(() => [
                        _createTextVNode("确认发布")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseButton), { click: onFailClick }, {
                      default: _withCtx(() => [
                        _createTextVNode("驳回修改")
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!configStatus.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_unref(BaseButton), { click: onPublishClick }, {
                      default: _withCtx(() => [
                        _createTextVNode("发布招商")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseButton), { click: onSaveClick }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (configStatus.value === 'review')
                ? (_openBlock(), _createBlock(_unref(BaseButton), {
                    key: 1,
                    click: onRevokeClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("撤回重新编辑")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (configStatus.value === 'fail')
                ? (_openBlock(), _createBlock(_unref(BaseButton), {
                    key: 2,
                    click: onReEditClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重新编辑")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (configStatus.value === 'success')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createVNode(_unref(BaseButton), { click: onReEditClick }, {
                      default: _withCtx(() => [
                        _createTextVNode("重新编辑")
                      ]),
                      _: 1
                    }),
                    (isStop.value)
                      ? (_openBlock(), _createBlock(_unref(BaseButton), {
                          key: 0,
                          click: onStartClick
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 启用招商 ")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_unref(BaseButton), {
                          key: 1,
                          click: onStopClick
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("暂停招商")
                          ]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(isOssRole) && formData.id)
                ? (_openBlock(), _createBlock(_unref(BaseButton), {
                    key: 4,
                    type: "warning",
                    click: onCopyClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 复制链接 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_unref(ConfigDetailVue), {
          perviewRole: 'c',
          content: formData.content,
          tags: formData.tags,
          "product-data": formData.productData
        }, null, 8, ["content", "tags", "product-data"])
      ])
    ])
  ])), [
    [_directive_xrk_loading, loading.value]
  ])
}
}

})